import React from "react";
import { Box, Checkbox, Flex, Label, Span } from "@catchoftheday/cg-components";
import { MAX_VISIBLE_LIST_FACET_OPTIONS } from "../../../consts";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var ListFacetOptions = function ListFacetOptions(_ref) {
  var options = _ref.options,
      showMore = _ref.showMore,
      onChange = _ref.onChange;
  return ___EmotionJSX(React.Fragment, null, options.map(function (_ref2, index) {
    var id = _ref2.id,
        value = _ref2.value,
        displayName = _ref2.displayName,
        children = _ref2.children,
        count = _ref2.count,
        selected = _ref2.selected;
    return ___EmotionJSX(Flex, {
      flexDirection: "row",
      key: id,
      mb: 2,
      display: index >= MAX_VISIBLE_LIST_FACET_OPTIONS && !showMore ? "none" : "flex",
      "data-testid": "list-facet-option"
    }, ___EmotionJSX(Flex, {
      alignItems: "center"
    }, ___EmotionJSX(Label, null, ___EmotionJSX(Checkbox, {
      id: id,
      name: value,
      value: value,
      inputContainerProps: {
        mr: 2
      },
      onChange: onChange,
      checked: selected
    }), ___EmotionJSX(Span, null, displayName), ___EmotionJSX(Span, {
      color: "typography.inactive",
      display: "inline-block",
      ml: 2
    }, "(", count, ")"))), children && children.length > 0 && ___EmotionJSX(Box, {
      ml: 2
    }, ___EmotionJSX(ListFacetOptions, {
      options: children,
      showMore: showMore,
      onChange: onChange
    })));
  }));
};